import {
  NovuProvider,
  PopoverNotificationCenter,
  NotificationBell,
} from '@novu/notification-center'
import { useSelector } from 'react-redux'
import authSelector from '@/redux/selectors/auth'
import { useRouter } from 'next/navigation'

const NovuNotificationCenter = () => {
  const { user } = useSelector(authSelector)
  const router = useRouter()
  const theme = {
    light: {
      loaderColor: '#2563EB',
    },
  }

  function onNotificationClick(message) {
    // your logic to handle the notification click
    if (message?.cta?.data?.url) {
      router.replace(message.cta.data.url)
    }
  }

  return (
    <NovuProvider
      subscriberId={user?.uid}
      applicationIdentifier={process.env.NEXT_PUBLIC_NOVU_APP_ID}
      backendUrl={process.env.NEXT_PUBLIC_APP_API_URL}
      socketUrl={process.env.NEXT_PUBLIC_APP_WS_URL}
    >
      <PopoverNotificationCenter
        colorScheme={'light'}
        theme={theme}
        onNotificationClick={onNotificationClick}
      >
        {({ unseenCount }) => <NotificationBell unseenCount={unseenCount} />}
      </PopoverNotificationCenter>
    </NovuProvider>
  )
}
export default NovuNotificationCenter
